import AOS from 'aos';

import './utils/vh.utils.js';
import './utils/animate-on-view.utils';

import './components/meta/select.component.js';
import './components/validation.component.js';

import './components/uploadFile.component.js';
import './components/header.component.js';
import './components/inputs.component.js';
import './components/text-sec-rows.component.js';
import './components/animations.component.js';
import './components/gradient-first.component.js';
import './components/gradient-bg-bubbles.component.js';
import './components/first-gradient-animation.component.js';
import './components/bg-first-parallax-animation.component.js';
import './components/player.component.js';
import './components/contact.component.js';
import './components/search-sec.component.js';
import './components/bind-filters-controls.component.js';

import './libs/countUp.lib.js';
import './libs/smoothScrollbar.lib.js';

import './components/sw-clients.component.js';
import './components/sw-services.component.js';
import './components/sw-jobs.component.js';
import './components/sw-core-values.component.js';
import './components/sw-purpose.component.js';
import './components/sw-solutions.component.js';
import './components/sw-our-markets.component.js';
import './components/sw-reviews.component.js';
import './components/sw-explore-hub.component.js';
import './components/sw-contact.component.js';
import './components/sw-blogs.component.js';

AOS.init();

let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

if (isSafari) document.body.classList.add('is-safari');
